import { PlatformSection } from '@/common/components';
import { useNewTranslations } from '@/common/translations';
import { TopGoalscorers, type TopGoalscorer } from '../../components';
import { usePrematchData } from '../../hooks';
import type { Goalscorer } from '../../types';
import { getPlayerFlagSrc } from '../../utils/getPlayerFlagSrc';

export default function TopGoalscorersSection() {
  const { teams, statistics } = usePrematchData();
  const translate = useNewTranslations();

  if (!statistics?.topGoalscorers) {
    return null;
  }

  function mapGoalscorer(goalscorer: Goalscorer, isHome: boolean): TopGoalscorer {
    return {
      name: goalscorer.name,
      goals: goalscorer.goals,
      position: translate(goalscorer.position),
      flagSrc: getPlayerFlagSrc(isHome, teams, goalscorer.flag),
    };
  }

  return (
    <PlatformSection name={translate('PreMatchStats.TopGoalscorers')}>
      <TopGoalscorers
        homeJerseySrc={teams.home.jersey}
        awayJerseySrc={teams.away.jersey}
        homeTopGoalscorers={statistics.topGoalscorers.home.map((goalscorer) =>
          mapGoalscorer(goalscorer, true),
        )}
        awayTopGoalscorers={statistics.topGoalscorers.away.map((goalscorer) =>
          mapGoalscorer(goalscorer, false),
        )}
      />
    </PlatformSection>
  );
}
